module.exports = {
	"id": "HK",
	"name": "Hong Kong",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.00615,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.01845,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.00615,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.0123,
			"23": null,
			"24": null,
			"25": 0.01845,
			"26": 0.00615,
			"27": null,
			"28": null,
			"29": 0.01845,
			"30": 0.00615,
			"31": 0.0369,
			"32": 0.00615,
			"33": 0.03075,
			"34": 0.01845,
			"35": 0.0246,
			"36": 0.0246,
			"37": 0.03075,
			"38": 0.0369,
			"39": 0.0492,
			"40": 0.0246,
			"41": 0.0246,
			"42": 0.1353,
			"43": 0.1476,
			"44": 0.1107,
			"45": 0.58425,
			"46": 0.0984,
			"47": 0.1599,
			"48": 0.1353,
			"49": 2.09715,
			"50": 0.3936,
			"51": 0.75645,
			"52": 1.0578,
			"53": 24.9321,
			"54": 6.00855,
			"55": 0.09225,
			"56": 0.03075,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.0123,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.0123,
			"12": 0.00615,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.0123,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.00615,
			"27": null,
			"28": 0.00615,
			"29": 0.00615,
			"30": 0.04305,
			"31": 0.0123,
			"32": null,
			"33": 0.03075,
			"34": 0.0246,
			"35": 0.03075,
			"36": 0.0123,
			"37": 0.0123,
			"38": 0.0738,
			"39": 0.04305,
			"40": 0.0369,
			"41": 0.0246,
			"42": 0.0492,
			"43": 0.09225,
			"44": 0.04305,
			"45": 0.1599,
			"46": 0.07995,
			"47": 0.41205,
			"48": 0.3936,
			"49": 4.59405,
			"50": 0.04305,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.0123
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.00615,
			"37": 0.0246,
			"38": 0.0615,
			"39": null,
			"40": 0.1599,
			"41": 0.0246,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03075
		},
		"safari": {
			"0": null,
			"4": 0.0123,
			"5": 0.0369,
			"6": 0.03075,
			"7": 0.1107,
			"8": 0.37515,
			"9": 0.33825,
			"10": 1.71585,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0984,
			"6.1": 0.0738,
			"7.1": 0.04305,
			"9.1": 1.4637
		},
		"ios_saf": {
			"8": 0,
			"10": 10.6089811407,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.28589976582,
			"8.1-8.4": 0.528187702956,
			"9.0-9.2": 0.251979454621,
			"9.3": 3.84430193589
		},
		"android": {
			"3": 0,
			"4": 0.0301533591731,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00376916989664,
			"4.1": 0.10876747416,
			"4.2-4.3": 0.271918685401,
			"4.4": 0.623528391473,
			"4.4.3-4.4.4": 0.628912919897
		},
		"ie": {
			"6": 0.0254193172356,
			"7": 0.0444838051624,
			"8": 0.635482930891,
			"9": 0.387644587843,
			"10": 0.311386636137,
			"11": 6.22137789342,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0270816307833,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000752267521759
		},
		"edge": {
			"12": 0.0861,
			"13": 0.58425,
			"14": 1.32225
		},
		"ie_mob": {
			"10": 0.014423943662,
			"11": 0.058726056338
		},
		"bb": {
			"7": 0.005775,
			"10": null
		},
		"samsung": {
			"0": 4.50835
		},
		"and_uc": {
			"0": 0.616
		},
		"op_mini": {
			"0": 0.364866101695
		},
		"and_chr": {
			"0": 18.48055
		},
		"and_ff": {
			"0": 0.02695
		}
	},
	"total": 98.9397701707
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/HK.json
 ** module id = 542
 ** module chunks = 0
 **/